import styled from 'styled-components';

import { BaseStyle, Select } from '@nhl/nhl-breakaway-ui';

import { SelectContainer } from '~/views/components/reportInputs/styles';

export const RowSizeContainer = styled(SelectContainer)`
    min-width: 96px;
    width: 100%;
`;

export const StyledSelect = styled(Select)`
    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        .MuiInput-input {
            min-width: 28px;
        }

        .select-dropdown-button {
            width: 40px;
        }
    }
`;
